const initialState = {
  bearerTokenAPI: null,
  evaluacion: {
    enEjecucionEvaluarAPI: true,
    datos: null,
    errorEvaluacion: false,
    mensaje: null
  },
  formalizacionCredito: {
    enEjecucionFormalizacionAPI: false,
    formalizacion: null,
    errorFormalizacion: false
  },
  cursarCredito: {
    enEjecucionCursarCreditoAPI: false,
    curse: null,
    errorApi: null,
    status: null,
    mensaje: null
  },
  autorizacion: {
    enEjecucionAutorizarAPI: false, // ESTADO DE EJECUCION DE LA API
    tipoAutorizacion: null, // CORDENADA O SMS
    datoRecibido: { coordenada: null, sms: null }, // DATOS QUE SE RECIBEN PARA VALIDAR
    datoParaValidar: null, // DATO QUE SE ENVIA A VALIDAR
    autorizacion: false, // SI FUE O NO FUE AUTORIZADO POR EL SERVICIO
    errorApi: null, // ERROR EN EL CONSUMO DE LA API
    status: null, // CODIGO DE VALIDACION O ERROR
    mensaje: null // DETALLE DEL MENSAJE
  },
  indicadorCurse: {
    enEjecucionCursarCreditoAPI: false,
    curse: null,
    errorApi: null
  },
  consultarSolicitud: {
    enEjecucionConsultarSolicitudAPI: false,
    consultarSolicitud: null,
    errorApi: null
  },
  enfermedadPreexistente: {
    data: {
      listaDeEnfermedadesApi: null,
      enfermedadesSeleccionadas: [],
      enfermedades: [],
      enEjecucionAPIEnfermedadesPreExistentes: false,
      errorApi: null,
      listaFormatoLabel: []
    }
  },
  documentosCredito: {
    enEjecucionObtenerDocumentoAPI_1: false,
    DoctoSolicitudProductoDeCredito_1: null,
    enEjecucionObtenerDocumentoAPI_2: false,
    DoctMandatoEspecialDeSuscripcion_2: null,
    enEjecucionObtenerDocumentoAPI_3: false,
    DoctAnexoLiquidacionDeCredito_3: null,
    enEjecucionObtenerDocumentoAPI_4: false,
    DoctContratoDeCredito_4: null,
    enEjecucionObtenerDocumentoAPI_5: false,
    DoctHojaResumenDeCredito_5: null,
    enEjecucionObtenerDocumentoAPI_6: false,
    DoctAnexoServicioAtencionAlCliente_6: null,
    enEjecucionObtenerDocumentoAPI_7: false,
    DoctSolIncorporacionYCertDeSeguros_7: null,
    enEjecucionObtenerDocumentoAPI_8: false,
    DoctPagare_8: null,
    errorApi: null
  },
  campanaVigente: {
    datos: null,
    enEjecucionAPICampana: false,
    trackId: null,
    token: null,
    fechaServidor: null,
    enEjecucionObtenerFechaAPI: false,
    idFlujo: null
  },
  datosPersona: {
    enEjecucionAPIDatosPersona: false,
    datosBasicosPersona: null,
    emailSocio: null
  },
  updateDatosPersona: {
    enEjecucionAPI: false,
    updatedatosPersona: null,
    error: null
  },
  steps: {
    stepActual: null,
    stepEstado: false,
    status: null,
    mensaje: null,
    nuevoEmail: '',
    enEjecucionAPIObtenerDesafio: false,
    enEjecucionAPIVerificarDesafio: false,
    coordenadas: {
      desafio1: 'A1',
      desafio2: 'B1',
      desafio3: 'C1'
    },
    datosVerificacion: null
  },
  condicionCredito: {
    data: {
      montoLiquidoCredito: '',
      plazo: '',
      primerVencimiento: '',
      ingresandoCondiciones: false,
      ultimoCampoModificado: null,
      nombreCampoError: null
    },
    ui: {
      openModal: false,
      mensajeError: false,
      imagenDni: false
    }
  },
  formaPago: {
    nombreFormaPago: ''
  },
  reliquidacionCredito: {
    creditoPagoDirecto: '',
    saldoInsoluto: '',
    cuotasPactadas: '',
    cuotasPagadas: '',
    tasaInteresMensual: '',
    valorCuota: ''
  },
  resumenCredito: {
    ui: {
      openModal: true
    }
  },
  conoceLeeContratos: {
    listaTipoContrato: [],
    tipoContrato: {
      nombreTipoContrato: '',
      idTipoContrato: '',
      listaDescripcionTipoContrato: [],
      descripcionTipoContrato: ''
    }
  },
  firmaElectronica: {
    correoSocio: '',
    mensajeEmail: '',
    enEjecucionEmailApi: false,
    aceptaTerminosCondiciones: false
  },
  felicitaciones: {
    nombreSocio: '',
    cuentaVistaNumero: '',
    montoLiquidoCredito: '',
    listaDocumentos: [],
    documento: {
      descargaDocumento: '',
      nombreDocumento: ''
    }
  },
  loader: {
    showLoader: false
  },
  modales: {
    showErrorGenerico: false,
    showEncuesta: false,
    enEjecucionAPIEncuesta: false,
    responseApi: null,
    errorApi: null,
    notaSocio: null
  },
  session: {
    tokenLive:null,
    trackId: null, // trackId DE LA SESION DEL USUARIO
    token: null, // TOKEN DE LA SESION
    idFlujo: null, // ID DE LUJO DE LA SESION
  }
  , simulacion: {
    estado: null,
    detalleSimulacion: null,
    enEjecucionAPISimulacion: false,
    codeError: null
  },
  solicitarCredito: {
    enEjecucionSolicitarAPI: false,
    solicitar: null,
    errorSolicitar: false
  },
  enviarSolicitudDocumentos:{
    enEjecucionEnviarSolicitud: false,
    enviarSolicitud: null,
    errorEnviarSolicitud: false
  },
  documentos: {
    documentosRecibidos: [
      { id: 1, name: "Cédula de identidad (Frente)"},
      { id: 2, name: "Cédula de identidad (Dorso)" },
      { id: 3, name: "última liquidación de sueldo ", mes: 1 },
      { id: 4, name: "última liquidación de sueldo ", mes: 2 },
      { id: 5, name: "última liquidación de sueldo ", mes: 3 },

      { id: 6, name: "últimas doce cotizaciones"},
      { id: 7, name: "comprobante de domicilio"},
    ],
    documentosCargados:[
      { id: 1, name: "Cédula de identidad (Frente)", estado: "Adjuntar", file:null, error:null, url:null, VisorPDF:null, extension:null,  idTipoDocumento: 1 },
      { id: 2, name: "Cédula de identidad (Dorso)", estado: "Adjuntar", file:null, error:null, url:null, VisorPDF:null, extension:null,  idTipoDocumento: 2 },
      { id: 3, name: "última liquidación de sueldo ", mes: 3, estado: "Adjuntar", file:null, error:null, url:null, VisorPDF:null, extension:null,  idTipoDocumento: 3},
      { id: 4, name: "última liquidación de sueldo ", mes: 2, estado: "Adjuntar", file:null, error:null, url:null, VisorPDF:null, extension:null,  idTipoDocumento: 4},
      { id: 5, name: "última liquidación de sueldo ", mes: 1, estado: "Adjuntar", file:null, error:null, url:null, VisorPDF:null, extension:null,  idTipoDocumento: 5},

      { id: 6, name: "últimas doce cotizaciones", estado: "Adjuntar", file:null, error:null, url:null, VisorPDF:null, extension:null,  idTipoDocumento: 6},
      { id: 7, name: "comprobante de domicilio", estado: "Adjuntar", file:null, error:null, url:null, VisorPDF:null, extension:null,  idTipoDocumento: 7},
    ]
  },
  rechazo:{
    showRechazo: false,
    enEjecucionAPI: false,
    motivosDisponible:[],
    motivo:null,
    responseApi: null,
    errorApi: null
  },
  seguros:{
    enEjecucionAPI:false,
    lista: [],
    seleccion: [],
    error:null
  },
  webViuw:{
    estado:false,
  }
};

export default initialState;